export default "__VITE_ASSET__Bk1djwJS__"